import { render, staticRenderFns } from "./UserPendingTransactions.vue?vue&type=template&id=122336e9&scoped=true&"
import script from "./UserPendingTransactions.vue?vue&type=script&lang=js&"
export * from "./UserPendingTransactions.vue?vue&type=script&lang=js&"
import style0 from "./UserPendingTransactions.vue?vue&type=style&index=0&id=122336e9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "122336e9",
  null
  
)

export default component.exports